"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeedbackModal = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactComponents = require("@cimpress/react-components");

var _environment = require("../../environment");

var _useFeedbackForm = require("../hooks/useFeedbackForm");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const FeedbackModal = props => {
  var _props$environment;

  const {
    show,
    showTitle,
    onTriggered,
    onSubmission,
    onSubmitted,
    onCancelled
  } = props;
  const previousShow = React.useRef(show);

  const handleSubmitted = data => {
    if (onSubmitted) {
      onSubmitted(data);
    }
  };

  const {
    feedbackHeader,
    feedbackContent,
    feedbackFooter,
    questions
  } = (0, _useFeedbackForm.useFeedbackForm)(_objectSpread(_objectSpread({}, props), {}, {
    environment: (_props$environment = props.environment) !== null && _props$environment !== void 0 ? _props$environment : _environment.ProductionEnvironment,
    onSubmitted: handleSubmitted,
    onSubmission
  }));
  React.useEffect(() => {
    if (show && !previousShow.current && onTriggered) {
      onTriggered();
    }
  }, [show, onTriggered]);
  previousShow.current = show;
  return /*#__PURE__*/React.createElement(_reactComponents.Modal, {
    bsStyle: 'info',
    closeOnOutsideClick: true,
    show: show && !!questions.result,
    onRequestHide: onCancelled,
    closeButton: false,
    title: showTitle ? feedbackHeader : undefined,
    footer: feedbackFooter
  }, feedbackContent);
};

exports.FeedbackModal = FeedbackModal;
FeedbackModal.defaultProps = {
  language: 'en',
  environment: _environment.ProductionEnvironment,
  showTitle: false
};